import React from 'react'
import { FormValueObject } from '#src/components/Path/Form'
import { PathFlowFragment } from '#src/generated/graphql'

export type FormContextType =
  | {
      // The entire path flow object
      pathFlow: PathFlowFragment
      // Is the form submitting
      isFormSubmitting: boolean
      // Is the form valid as a whole
      isFormValid: boolean
      // When the validity of a question is changed - decided by the question itself
      onFieldValidityChanged: (name: string, valid: boolean) => void
      // When the value of a question is changed - decided by the question itself
      onFieldValueChanged: (
        name: string,
        value: FormValueObject,
        callback?: (() => void) | undefined
      ) => void
      // On the page (form) submitted
      onPageSubmitted: () => void
    }
  | undefined

const FormContext = React.createContext<FormContextType>(undefined)

const FormContextProvider = FormContext.Provider
const FormContextConsumer = FormContext.Consumer

export { FormContextConsumer, FormContextProvider }
